/** @format */

export const CGST_PERCENTAGE = 2.5;
export const SGST_PERCENTAGE = 2.5;
export const CATEGORY_NAME_CHARACTER_LIMIT = 18;
export const ITEM_NAME_CHARACTER_LIMIT = 20;
export const ITEM_DESCRIPTION_CHARACTER_LIMIT = 300;
export const ITEM_INGREDIENT_CHARACTER_LIMIT = 200;
